import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';

// The Font Awesome Light set, loaded here and nowhere in the shell.
import '@fortawesome/fontawesome-pro/css/fontawesome.css';
import '@fortawesome/fontawesome-pro/css/light.css';

// The professor interests (Phase 5 PR 5.4, brief Q11 A): the one data-driven
// Font Awesome set that stays Font Awesome (O105 keeps the package), behind
// this app-level component, outside Helios. Each interest in
// utils/professors.json's `identity` names a key here: its title and its
// Font Awesome Light glyph. The map moved from pages/sites/[site]/professors/
// [slug].js unchanged.
export const INTERESTS = {
  actor: {
    title: 'Actor',
    icon: 'fa-theater-masks'
  },
  artAppreciator: {
    title: 'Art Appreciator',
    icon: 'fa-paint-brush'
  },
  baker: {
    title: 'Baker',
    icon: 'fa-croissant'
  },
  basketballFan: {
    title: 'Basketball Fan',
    icon: 'fa-basketball-ball'
  },
  bookworm: {
    title: 'Bookworm',
    icon: 'fa-books'
  },
  broadwayStan: {
    title: 'Broadway Stan',
    icon: 'fa-piano'
  },
  capoeirista: {
    title: 'Capoeirista',
    icon: 'fa-walking'
  },
  catLover: {
    title: 'Cat Lover',
    icon: 'fa-cat'
  },
  chef: {
    title: 'Chef',
    icon: 'fa-hat-chef'
  },
  chessPlayer: {
    title: 'Chess Player',
    icon: 'fa-chess'
  },
  chickenOwner: {
    title: 'Chicken Owner',
    icon: 'fa-egg'
  },
  christian: {
    title: 'Christian',
    icon: 'fa-cross'
  },
  comedyLover: {
    title: 'Comedy Lover',
    icon: 'fa-comment-smile'
  },
  comedyWriter: {
    title: 'Comedy Writer',
    icon: 'fa-comment-smile'
  },
  communityCollegeGrad: {
    title: 'Community College Grad',
    icon: 'fa-exchange'
  },
  dancer: {
    title: 'Dancer',
    icon: 'fa-shoe-prints'
  },
  designer: {
    title: 'Designer',
    icon: 'fa-palette'
  },
  dogLover: {
    title: 'Dog Lover',
    icon: 'fa-dog'
  },
  entrepreneur: {
    title: 'Entrepreneur',
    icon: 'fa-lightbulb'
  },
  feministScholar: {
    title: 'Feminist Scholar',
    icon: 'fa-book-reader'
  },
  firstGen: {
    title: 'First-gen',
    icon: 'fa-circle-1'
  },
  foodie: {
    title: 'Foodie',
    icon: 'fa-utensils'
  },
  footballFan: {
    title: 'Football Fan',
    icon: 'fa-football-ball'
  },
  gamer: {
    title: 'Gamer',
    icon: 'fa-gamepad-modern'
  },
  hiker: {
    title: 'Hiker',
    icon: 'fa-mountains'
  },
  historyBuff: {
    title: 'History Buff',
    icon: 'fa-book-open'
  },
  holidayEnthusiast: {
    title: 'Holiday Enthusiast',
    icon: 'fa-jack-o-lantern'
  },
  internationalEducator: {
    title: 'International Educator',
    icon: 'fa-globe-americas'
  },
  inventor: {
    title: 'Inventor',
    icon: 'fa-cogs'
  },
  lawyer: {
    title: 'Lawyer',
    icon: 'fa-balance-scale'
  },
  practicingAttorney: {
    title: 'Practicing Attorney',
    icon: 'fa-balance-scale'
  },
  lgbtq: {
    title: 'LGBTQ+',
    icon: 'fa-mars-double'
  },
  literatureBuff: {
    title: 'Literature Buff',
    icon: 'fa-book'
  },
  movieBuff: {
    title: 'Movie Buff',
    icon: 'fa-camera-movie'
  },
  multilingual: {
    title: 'Multilingual',
    icon: 'fa-language'
  },
  musicalTheaterStan: {
    title: 'Musical Theater Stan',
    icon: 'fa-piano'
  },
  musicLover: {
    title: 'Music Lover',
    icon: 'fa-music'
  },
  philosopher: {
    title: 'Philosopher',
    icon: 'fa-building columns'
  },
  podcaster: {
    title: 'Podcaster',
    icon: 'fa-microphone-alt'
  },
  pokerPlayer: {
    title: 'Poker Player',
    icon: 'fa-spade'
  },
  publicSpeaker: {
    title: 'Public Speaker',
    icon: 'fa-podium'
  },
  realityTVstan: {
    title: 'Reality TV Stan',
    icon: 'fa-tv-retro'
  },
  runner: {
    title: 'Runner',
    icon: 'fa-running'
  },
  sandwichLover: {
    title: 'Sandwich Lover',
    icon: 'fa-sandwich'
  },
  seamstress: {
    title: 'Seamstress',
    icon: 'fa-reel'
  },
  singer: {
    title: 'Singer',
    icon: 'fa-microphone-stand'
  },
  skydiver: {
    title: 'Skydiver',
    icon: 'fa-parachute-box'
  },
  smoothieLover: {
    title: 'Smoothie Lover',
    icon: 'fa-blender'
  },
  soccerCoach: {
    title: 'Soccer Coach',
    icon: 'fa-futbol'
  },
  soccerLover: {
    title: 'Soccer Lover',
    icon: 'fa-futbol'
  },
  techHead: {
    title: 'Tech-Head',
    icon: 'fa-computer-speaker'
  },
  traveler: {
    title: 'Traveler',
    icon: 'fa-suitcase'
  },
  worldTraveler: {
    title: 'World Traveler',
    icon: 'fa-suitcase'
  },
  trailRunner: {
    title: 'Trail Runner',
    icon: 'fa-running'
  },
  tvMysteriesStan: {
    title: 'TV Mysteries Stan',
    icon: 'fa-search'
  },
  writer: {
    title: 'Writer',
    icon: 'fa-pen-nib'
  },
  stampCollector: {
    title: 'Stamp Collector',
    icon: 'fa-stamp'
  },
  swimmer: {
    title: 'Swimmer',
    icon: 'fa-person-swimming'
  },
  dataScienceExpert: {
    title: 'Data Science Expert',
    icon: 'fa-chart-line'
  },
  machineLearningEnthusiast: {
    title: 'Machine Learning Enthusiast',
    icon: 'fa-robot'
  },
  bonsaiLover: {
    title: 'Bonsai Lover',
    icon: 'fa-seedling'
  },
  gardening: {
    title: 'Gardening',
    icon: 'fa-seedling'
  },
  cooking: {
    title: 'Cooking',
    icon: 'fa-hat-chef'
  },
  traveling: {
    title: 'Traveling',
    icon: 'fa-suitcase'
  },
  singerMusician: {
    title: 'Singer & Musician',
    icon: 'fa-microphone-stand'
  },
  painter: {
    title: 'Painter',
    icon: 'fa-paint-brush'
  },
  japanResident: {
    title: 'Lived in Japan',
    icon: 'fa-torii-gate'
  },
  foreignLanguageEnthusiast: {
    title: 'Foreign Language Enthusiast',
    icon: 'fa-language'
  },
  winemaker: {
    title: 'Winemaker',
    icon: 'fa-wine-glass'
  },
  jazzLover: {
    title: 'Jazz Lover',
    icon: 'fa-music'
  },
  veteran: {
    title: 'Veteran',
    icon: 'fa-medal'
  },
  author: {
    title: 'Author',
    icon: 'fa-book'
  },
  tennisPlayer: {
    title: 'Tennis Player',
    icon: 'fa-tennis-ball'
  },
  professionalTennisPlayer: {
    title: 'Professional Tennis Player',
    icon: 'fa-tennis-ball'
  },
  philanthropist: {
    title: 'Philanthropist',
    icon: 'fa-hand-holding-heart'
  },
  natureLover: {
    title: 'Nature Lover',
    icon: 'fa-leaf'
  },
  gardener: {
    title: 'Gardener',
    icon: 'fa-seedling'
  },
  coffeeLover: {
    title: 'Coffee Lover',
    icon: 'fa-mug-hot'
  },
  martialArtist: {
    title: 'Black Belt in Karate',
    icon: 'fa-hand-fist'
  },
  golfer: {
    title: 'Golfer',
    icon: 'fa-golf-club'
  },
  pickleballer: {
    title: 'Pickle Baller',
    icon: 'fa-table-tennis-paddle-ball'
  },
  proudMom: {
    title: 'Proud Mom',
    icon: 'fa-heart'
  },
  combatVeteranSpouse: {
    title: 'Combat Veteran Spouse',
    icon: 'fa-flag-usa'
  },
  pugRescuer: {
    title: 'Pug Rescuer',
    icon: 'fa-dog'
  },
  lifelongLearner: {
    title: 'Lifelong Learner',
    icon: 'fa-graduation-cap'
  },
  fashionLover: {
    title: 'Fashion Lover',
    icon: 'fa-scissors'
  },
  fitnessEnthusiast: {
    title: 'Fitness Enthusiast',
    icon: 'fa-dumbbell'
  },
  avidChef: {
    title: 'Avid Chef',
    icon: 'fa-hat-chef'
  },
  u2Fan: {
    title: 'U2 Fan',
    icon: 'fa-compact-disc'
  },
  indyCarFan: {
    title: 'IndyCar Fan',
    icon: 'fa-flag-checkered'
  },
  aiBuilder: {
    title: 'AI Builder',
    icon: 'fa-robot'
  },
  animalLover: {
    title: 'Animal Lover',
    icon: 'fa-paw'
  },
  trueCrimeEnthusiast: {
    title: 'True-Crime Enthusiast',
    icon: 'fa-user-secret'
  },
  birdwatcher: {
    title: 'Birdwatcher',
    icon: 'fa-bird'
  },
  disneyFan: {
    title: 'Disney Fan',
    icon: 'fa-castle'
  },
  conversationsWithStrangers: {
    title: 'Deep conversations with strangers',
    icon: 'fa-comments'
  },
  keepingPlantsAlive: {
    title: 'Keeping plants alive',
    icon: 'fa-seedling'
  },
  documentariesAndPodcasts: {
    title: 'Documentaries & podcasts',
    icon: 'fa-camera-movie'
  }
};

/**
 * The interest's Font Awesome Light glyph: the same `<i>` the detail page
 * rendered (no text; the title beside it names the interest).
 *
 * @param {{icon: string}} props an entry's `icon` class, e.g. `fa-paw`
 */
function InterestIcon(t0) {
  const $ = _c(4);
  const {
    icon
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = classNames("fa-light", icon);
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <i className={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export default InterestIcon;